<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>

        <!-- Add mode: dropdown to pick the parent Hotel Room -->
        @if (!hotelListingId) {
          <div class="col-lg-12">
            <span class="p-float-label required-field w-100 mb-3">
              <p-dropdown [options]="properties" formControlName="hotelShortTermRentalId" optionLabel="propertyCode" optionValue="shortTermRentalId" [filter]="true" filterBy="propertyCode" [showClear]="false"
                appendTo="body" placeholder="Select Hotel Room Parent">
              </p-dropdown>
              <label for="Select Hotel Room Parent">Select Hotel Room Parent</label>
              @for (validation of validationMessages.hotelShortTermRentalId; track validation) {
                <span>
                  @if (form1.get('hotelShortTermRentalId').hasError(validation.type) && (form1.get('hotelShortTermRentalId').dirty || form1.get('hotelShortTermRentalId').touched)) {
                    <small class="p-invalid">{{validation.message}}</small>
                  }
                </span>
              }
            </span>
          </div>
        }
        <!-- Edit mode: read-only display — parent cannot be changed after creation -->
        @if (hotelListingId) {
          <div class="col-lg-12 mb-3">
            <small class="text-muted d-block" style="font-size: 0.78rem; margin-bottom: 2px;">Hotel Room Parent</small>
            <span class="fw-semibold">{{ getParentPropertyCode() }}</span>
            <small class="text-muted ms-2">(read-only)</small>
          </div>
        }

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <p-dropdown [options]="childPropertyOptions" formControlName="shortTermRentalId" optionLabel="propertyCode" optionValue="shortTermRentalId" [filter]="true" filterBy="propertyCode" [showClear]="false"
              appendTo="body" placeholder="Select Child Unit">
            </p-dropdown>
            <label for="Select Child Unit">Select Child Unit
              <small class="text-muted">(standard STR or Composite — no nested Hotel Room)</small>
            </label>
            @for (validation of validationMessages.shortTermRentalId; track validation) {
              <span>
                @if (form1.get('shortTermRentalId').hasError(validation.type) && (form1.get('shortTermRentalId').dirty || form1.get('shortTermRentalId').touched)) {
                  <small class="p-invalid">{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <p-dropdown [options]="sitePriorities" formControlName="listingPriority" optionLabel="name" optionValue="value" [showClear]="false" appendTo="body"
              placeholder="Listing Priority">
            </p-dropdown>
            <label for="listingPriority">Listing Priority</label>
            @for (validation of validationMessages.listingPriority; track validation) {
              <span>
                @if (form1.get('listingPriority').hasError(validation.type) && (form1.get('listingPriority').dirty || form1.get('listingPriority').touched)) {
                  <small class="p-invalid">{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
      </div>
    </div>
    <hr>
      <div class="row m-0">
        <div class="col-lg-12">
          <div class="btn-group">
            <div class="button-group">
              @if (hotelListingId) {
                <button pButton class="btn-delete p-button-outlined p-button-danger"
                (click)="onFormDelete()">Delete</button>
              }
            </div>

            <div class="button-group">
              <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
              @if (!hotelListingId) {
                <button pButton class="btn-addt p-button" (click)="formAdd()">Add</button>
              }

              @if (hotelListingId) {
                <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update</button>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
